import React, { useEffect } from 'react'
import ReviewParameter from './ReviewParameter'
import filter from 'lodash/filter'

import {
  IProjectVersionSettingsReviewParameterOption,
} from '@SiteModules/ProjectVersionSettings/types'

const REVIEW_SOURCE_TRANSCRIPT_OPTION = 'review_source_transcript'
const REVIEW_CLIP_TRANSCRIPT_OPTION = 'review_clip_transcript'

interface ReviewForRepurposeParameterProps {
  readonly reviewModeOptionsForRepurpose: string[]
  readonly hasNewTranscription: boolean
  readonly willTranslate: boolean
  setReviewModeOptionsForRepurpose(newReviewModeOptionsForRepurpose: string[]): void
}

const ReviewForRepurposeParameter: React.FC<ReviewForRepurposeParameterProps> = props => {
  const {
    reviewModeOptionsForRepurpose,
    hasNewTranscription,
    willTranslate,
  } = props

  const availableOptions: IProjectVersionSettingsReviewParameterOption[] = [{
    name: REVIEW_SOURCE_TRANSCRIPT_OPTION,
    nameToShowInDropdown: 'Review source transcript (best quality)',
    description: hasNewTranscription ? 'Correct the transcript of your original video to improve clip generation and overall accuracy.' : 'Transcript already generated.',
    disabled: !hasNewTranscription
  }, {
    name: REVIEW_CLIP_TRANSCRIPT_OPTION,
    nameToShowInDropdown: 'Review clips before translation (full control)',
    description: willTranslate ? 'Approve and adjust clips before translations are generated.' : 'Available when translation is enabled.',
    disabled: !willTranslate
  }]

  useEffect(() => {
    if (!willTranslate && reviewModeOptionsForRepurpose.includes(REVIEW_CLIP_TRANSCRIPT_OPTION)) {
      const newReviewOptions = filter(reviewModeOptionsForRepurpose, reviewOption => reviewOption !== REVIEW_CLIP_TRANSCRIPT_OPTION)
      props.setReviewModeOptionsForRepurpose(newReviewOptions)
    }
  }, [willTranslate])

  const numberOfOptions = availableOptions.length
  let buttonText = ''

  if (reviewModeOptionsForRepurpose.length === 0) {
    buttonText = '🚀 Automatic (fastest)'
  } else if (reviewModeOptionsForRepurpose.length === numberOfOptions) {
    buttonText = '🛡️ Full manual review'
  } else if (reviewModeOptionsForRepurpose[0] === REVIEW_SOURCE_TRANSCRIPT_OPTION) {
    buttonText = '📝 Review transcript'
  } else if (reviewModeOptionsForRepurpose[0] === REVIEW_CLIP_TRANSCRIPT_OPTION) {
    buttonText = '🎬 Review clips'
  }

  return (
    <ReviewParameter
      reviewModeOptions={reviewModeOptionsForRepurpose}
      availableOptions={availableOptions}
      setReviewModeOptions={props.setReviewModeOptionsForRepurpose}
      buttonText={buttonText}
    />
  )
}

export default ReviewForRepurposeParameter
